import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';

import * as Objects from '@core/objects';
import * as Search from '@app/models/search';
import { VersionFeedback } from '@core/models/version-feedback';

import * as fromState from '@app/store/state/approvals/approvals.state';
import * as fromActions from '@app/store/state/approvals/approvals.actions';

@Injectable({
    providedIn: 'root'
})
export class ApprovalsFiltersService {

    constructor(private store: Store<fromState.Approvals>, private actions$: Actions) {}

    loadLabelsFilter = () => this.store.dispatch( new fromActions.LoadFilterLabels());

    loadUsersFilter = () => this.store.dispatch( new fromActions.LoadFilterUsers());

    selectLabels = ():  Observable<Search.SearchAvailableFilters> => this.store.select(fromState.availableFilterLabelsSelector);

    selectUsers = ():  Observable<Search.SearchAvailableFilters> => this.store.select(fromState.availableFilterUsersSelector);

    selectFilterInitializedStatus = ( ) :Observable<fromState.ApprovalsAvailableFiltersStatus> => this.store.select(fromState.availableFiltersInitializedStatusSelector);
}

@Injectable({
    providedIn: 'root'
})
export class ApprovalsSearchService {

    constructor(private store: Store<fromState.Approvals>, private actions$: Actions) {}

    applyFilter = (filter: Search.SearchAppliedFilter) => this.store.dispatch( new fromActions.ApplySearchFilter(filter));

    removeFilter = (filter: Search.SearchAppliedFilter) => this.store.dispatch( new fromActions.RemoveSearchFilter(filter));

    setTerm = (term: string) => this.store.dispatch( new fromActions.SetSearchTerm(term));

    selectFilters = () :  Observable<Search.SearchAppliedFilter[]> => this.store.select(fromState.searchFiltersSelector);

    selectTerm = () :  Observable<string> => this.store.select(fromState.searchTermSelector);

}

@Injectable({
    providedIn: 'root'
})
export class ApprovalsService {

    constructor(private store: Store<fromState.Approvals>, private actions$: Actions) {}

    init = (params: Search.SearchQueryParams, feedbackAccess: boolean, globalAccess: boolean | string) => this.store.dispatch( new fromActions.Init(params,feedbackAccess, globalAccess));

    selectError = (key: string): Observable<HttpErrorResponse> => this.store.select(fromState.errorSelector(key));
    
    loadResults = () => this.store.dispatch( new fromActions.LoadResults());

    loadMoreCompletedResults = () => this.store.dispatch( new fromActions.LoadMoreCompletedResults());
    
    loadMoreUncompletedResults = () => this.store.dispatch( new fromActions.LoadMoreUncompletedResults());

    updateVersion = (vid: number | string, eventName: string) => this.store.dispatch( new fromActions.UpdateVersion(vid, eventName));
    
    updateVersionFeedbacks = (vid: number) => this.store.dispatch( new fromActions.UpdateVersionFeedbacks(vid));

    setVersionStatus = (vid: number | string, status: Objects.Status) => this.store.dispatch( new fromActions.SetVersionStatus(+vid, status));

    selectOutstandingResults = () : Observable<Objects.Version[]> => this.store.select(fromState.resultUncompletedItemsSelector);

    selectCompletedResults = () : Observable<Objects.Version[]> => this.store.select(fromState.resultCompletedItemsSelector);
    
    selectResultsOutstandingItems = () : Observable<Objects.Version[]> => this.store.select(fromState.resultUncompletedItemsSelector);

    selectResultsCompletedItemsSelector = () : Observable<Objects.Version[]> => this.store.select(fromState.resultCompletedItemsSelector);
    
    selectResultStatus = () : Observable<fromState.ApprovalsResultsStatus> => this.store.select(fromState.resultStatusSelector);

    setResultItemsStatus = (status: string) => this.store.dispatch( new fromActions.UpdateResultItemsStatus(status));

    selectResultItems = () : Observable<Objects.Version[]> => this.store.select(fromState.resultItemsSelector);

    selectResultSelectedStatus = () : Observable<string> => this.store.select(fromState.resultSelectStatusSelector);

    selectResultsFeedbacks = () : Observable<VersionFeedback[]> => this.store.select(fromState.resultFeedbacksSelector);

    selectCompletedResultsFeedbacks = () : Observable<VersionFeedback[]> => this.store.select(fromState.resultCompletedFeedbacksSelector);

    selectResultsFeedbacksStatus = () : Observable<fromState.ApprovalsResultsStatus> => this.store.select(fromState.resultFeedbacksStatusSelector);

    selectEvents = () : Observable<{name: string, id: number | string}[]> => this.store.select(fromState.eventsSelector);

    selectQueryParams = () :  Observable<Search.SearchQueryParams> => this.store.select(fromState.queryParamsSelector);

    reset = () => this.store.dispatch(new fromActions.Clear());

    // global property selector
    selectFeedbacksResults = () : Observable<fromState.ApprovalsResultsFeedbacks> => this.store.select(fromState.approvalsResultsFeedbacksSelector);

}
